import {
  CreateCategoriesRequest,
  ProductDetailsResponseDto,
  ProductImageRequestDto,
  TagRequest,
} from '@tiendanube/common';
import { UpdateImagesRequest } from '@tiendanube/common/src/domains/catalog/interfaces/unstable/sub-entities/ImagesRequest';

export function getTags(tags: string | undefined): TagRequest[] {
  if (!tags) return [];
  return tags.split(',').map((tag) => ({
    tag: tag.trim(),
  }));
}

export function getCategories(
  categories: string[] | undefined,
): CreateCategoriesRequest[] {
  if (!categories) return [];
  return categories.map((category, index) => ({
    id: Number(category),
    order: index,
  }));
}

export function getImages(
  images: ProductImageRequestDto[],
): UpdateImagesRequest[] {
  if (!images.length) return [];
  return images.map((image, index) => ({
    id: Number(image.image_id),
    order: index,
  }));
}

export function createResponseDto(
  createdId: number,
): ProductDetailsResponseDto {
  return { id: createdId } as unknown as ProductDetailsResponseDto;
}
